import styled, { css } from 'styled-components';

import { breakpoints, QuantitySelector } from '@notino/react-styleguide';

const getGridTemplateAreas = (
  isClickAndCollect: boolean,
  isLoyaltyDiscount: boolean
) => {
  if (isClickAndCollect && isLoyaltyDiscount) {
    return css`
      grid-template-areas:
        'loyalty'
        'addToCart'
        'clickAndCollect';
      @media (min-width: ${breakpoints.sm}) {
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-areas:
          'loyalty loyalty loyalty'
          'addToCart clickAndCollect _';
      }
    `;
  }
  if (isLoyaltyDiscount) {
    return css`
      grid-template-areas:
        'loyalty'
        'addToCart';
    `;
  }
  if (isClickAndCollect) {
    return css`
      grid-template-areas:
        'addToCart'
        'clickAndCollect';
      @media (min-width: ${breakpoints.sm}) {
        grid-template-columns: auto auto 1fr;
        grid-template-areas: 'addToCart clickAndCollect';
      }
    `;
  }
  return css`
    grid-template-areas: 'addToCart';
  `;
};

const getNewGridTemplateAreas = (
  isClickAndCollect: boolean,
  isLoyaltyDiscount: boolean
) => {
  if (isClickAndCollect && isLoyaltyDiscount) {
    return css`
      grid-template-areas:
        'loyalty'
        'addToCart'
        'clickAndCollect';
    `;
  }
  if (isLoyaltyDiscount) {
    return css`
      grid-template-areas:
        'loyalty'
        'addToCart';
    `;
  }
  if (isClickAndCollect) {
    return css`
      grid-template-areas:
        'addToCart'
        'clickAndCollect';
    `;
  }
  return css`
    grid-template-areas: 'addToCart';
  `;
};

export const BuyButtons = styled.div<IWrapperProps>`
  display: grid;
  align-items: center;

  ${({ newDesign, isClickAndCollect, isLoyaltyDiscount, canBuy }) =>
    newDesign
      ? css`
          width: 100%;
          grid-gap: 0.5rem;
          padding: 1rem 0 1.5rem;
          ${getNewGridTemplateAreas(isClickAndCollect, isLoyaltyDiscount)}
        `
      : css`
          ${getGridTemplateAreas(isClickAndCollect, isLoyaltyDiscount)}
          grid-gap: 1rem;
          padding: 1rem 0;

          @media (min-width: ${breakpoints.sm}) {
            grid-gap: ${canBuy ? '2rem 1rem' : '0rem'};
          }
        `}
`;

export const ButtonWrapper = styled.div<{ newDesign: boolean }>`
  & > button,
  form button {
    padding: 0 0.5625rem !important;
    height: 2.75rem;
    min-width: 7.5rem;
    text-transform: none !important;
    font-weight: normal !important;
  }
  flex: 1;
  min-width: 7.5rem;

  ${({ newDesign }) =>
    newDesign
      ? css`
          & > button,
          form button {
            height: 3.25rem;
          }
        `
      : css`
          @media (min-width: ${breakpoints.sm}) {
            flex: 0 1;
          }
        `}
`;

export const Label = styled.label`
  display: none;
`;

export const DropdownButtonSeparator = styled.div<{ newDesign: boolean }>`
  ${({ newDesign }) =>
    newDesign ? 'padding-right: 0.5rem' : 'padding-right: 1rem'}
`;

export const QuantityWrapper = styled.div`
  width: 5.25rem;
  font-size: 0.875rem;
  & > div > div {
    min-height: 2.75rem;
  }
`;

interface IWrapperProps {
  isClickAndCollect?: boolean;
  isLoyaltyDiscount?: boolean;
  canBuy?: boolean;
  newDesign: boolean;
}

export const AddToCartWrapper = styled.div<IWrapperProps>`
  grid-area: addToCart;

  display: flex;
  align-items: center;
`;

export const ClickAndCollectWrapper = styled.div<IWrapperProps>`
  grid-area: clickAndCollect;

  ${({ isClickAndCollect, newDesign }) =>
    isClickAndCollect &&
    css`
      margin-top: ${newDesign ? '-0.5rem' : '-1rem'};
    `}

  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const LoyaltyDiscountWrapper = styled.div<IWrapperProps>`
  grid-area: loyalty;

  ${({ newDesign }) =>
    newDesign &&
    css`
      margin-bottom: 0.75rem;
      width: 100%;
    `}
`;

export const StyledQuantitySelector = styled(QuantitySelector)<{
  newDesign: boolean;
}>`
  ${({ newDesign }) =>
    newDesign &&
    css`
      [role='combobox'] {
        height: 3.25rem;
      }
    `}
`;
